import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

// Helper to generate random numbers
const random = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

// Animation keyframes
const blow = (distance) => keyframes`
  0% {
    opacity: 0;
    transform: translateY(0) scale(1);
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(-${distance}px) scale(0.5); // slightly bigger shrink
  }
`;

// Styled components
const Container = styled.div`
  height: 100vh;
  background-color: #00bfff; /* New background color */
  overflow: hidden;
  position: relative;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const BubbleContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`;

const Bubble = styled.div`
  position: absolute;
  bottom: 0;
  width: 2rem; /* bigger bubbles */
  height: 2rem; /* bigger bubbles */
  background-color: rgba(75, 0, 130, 0.8);
  border-radius: 50%;
  animation: ${({ distance, speed }) => blow(distance)} ${({ speed }) => speed}ms
    infinite;
  animation-delay: ${({ delay }) => delay}ms;
  left: ${({ left }) => left}%;
`;

export default function BubblesRising({ count = 20 }) {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    setHeight(window.innerHeight);
    const handleResize = () => setHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const bubbles = Array.from({ length: count }, () => ({
    left: random(0, 100),
    speed: random(5000, 15000),
    delay: random(0, 12000),
    distance: height || 600,
  }));

  return (
    <Container>
      {/* <h1>CSS Rising Bubbles (React)</h1>
      <p>Originally by Paulo Duzioni</p> */}
      <BubbleContainer>
        {bubbles.map((bubble, index) => (
          <Bubble
            key={index}
            left={bubble.left}
            speed={bubble.speed}
            delay={bubble.delay}
            distance={bubble.distance}
          />
        ))}
      </BubbleContainer>
    </Container>
  );
}
